import Commander from "./Commander";
import BigWin from "./BigWin";
import {pixiSetTimeout} from "../framework/src/engine/pixi/pixiTimeout";
import {STATES} from "../framework/src/states/states";


export default class Freespins {
    constructor (commander) {
        this.commander = commander;
        this.BlinkAnimation = this.commander.BlinkAnimation;
        this.NormalWin = this.commander.NormalWin;
        this.BigWin = this.commander.BigWin;
        this.StickingWild = this.commander.StickingWild;
        this.Coins = this.commander.Coins;
        this.WinCounter = this.commander.WinCounter;

        this.freespins = this.commander.freespins;
        this.isRunning = false

        this.layer = this.commander.layers.freespins;
        this.doors = {
            tween: { x: 0 }
        };

        this.text = {
            current: undefined,
            total: undefined,
            fs: undefined
        }
    }

    init() {
        this.initCounter();
        this.initDoors();
        this.initText();
        this.initDoorLights();
    }

    async run(result) {

        this.isRunning = true
        this.commander.states.setState(STATES.BONUS);

        this.NormalWin.showAllWinPositions(result);
        this.NormalWin.showGrid();
        this.NormalWin.hideLogo();
        await new Promise(res => this.blinkStars(result.lineWins[0].position, res));

        this.freespins.run(result);
        await this.closeDoors();
        await this.showLights();
        this.showJokers();
        this.commander.slowerLights();
        this.commander.audio.playTrack("bonus_Panel_Appear");
        this.showCounter();
        await this.openDoors();
        this.freespins.isSkipping() && this.commander.setWin(this.freespins.getResultWin());

        await this.commander.endRound();
        this.commander.TouchZone.hide();
        this.commander.TouchZone.zonesOff();
    }

    blinkStars(position, callback = () => {}) {
        return new Promise(res => {
            this.commander.audio.playTrack("win_Star");
            let symbols = this.commander.slots.getResultSymbols();
            for (let pos of position) {
                this.BlinkAnimation.addTarget(symbols[pos[0]*4+pos[1]]);
            }
            pixiSetTimeout(2.5, () => {
                this.BlinkAnimation.clearTargetFilters();
                res();
            });
        }).then(() => {
            this.commander.audio.playTrack("bg_FreeSpins_Start");

            pixiSetTimeout(0.500, () => {
                this.commander.audio.playTrack("bg_FreeSpins_Loop");
            });

            this.NormalWin.resetWinPositions();
            this.NormalWin.hideLights();
            this.NormalWin.hideGrid();
            this.NormalWin.showLogo();
            callback();
        });
    }

    closeDoors() {
        return new Promise(res => {
            this.commander.audio.setVolume("bonus_Door_Close", 0.7) ;
            this.commander.audio.fadeInPlaying("bonus_Door_Close", 20);
            createjs.Tween.get(this.doors.tween)
                .to( {x: 645}, 800, createjs.Ease.bounceOut)
                .call(() => {
                    Commander.removeTween(this.doors.tween);
                    res();
                })
                .addEventListener('change', () => {
                    this.doors.left.x = -641+this.doors.tween.x;
                    this.doors.right.x = 1930-this.doors.tween.x;
                });
        })
    }

    showLights() {
        return new Promise(res => {
            let tween = {alpha: 0};
            createjs.Tween.get(tween)
                .to({alpha: 1}, 500)
                .call(() => {
                    this.blinkLights();
                })
                .wait(1000)
                .to({alpha: 0}, 500)
                .call(() => {
                    Commander.removeTween(tween);
                    Commander.removeTween(this.lights);
                    res();
                })
                .addEventListener("change", () => {
                    this.text.fs.alpha = this.lights.alpha = tween.alpha;
                });
        });
    }

    showJokers() {
        this.StickingWild.hideReelsBg();
        this.StickingWild.instantHideJokers();
        this.StickingWild.redBackground();
        this.StickingWild.showJoker(0);
        this.StickingWild.showJoker(2);
        this.StickingWild.showJoker(4);
    }

    openDoors() {
        return new Promise(res => {
            this.commander.audio.setVolume("bonus_Door_Open", 0.7) ;
            this.commander.audio.fadeInPlaying("bonus_Door_Open", 100);
            createjs.Tween.get(this.doors.tween)
                .to( {x: 0}, 800, createjs.Ease.cubicIn)
                .call(() => {
                    Commander.removeTween(this.doors.tween);
                    res();
                })
                .addEventListener('change', () => {
                    this.doors.left.x = -641+this.doors.tween.x;
                    this.doors.right.x = 1930-this.doors.tween.x;
                });
        })
    }

    blinkLights() {
        createjs.Tween.get(this.lights, {loop: true})
            .wait(100)
            .call(() => {
                this.lights.visible = false;
            })
            .wait(100)
            .call(() => {
                this.lights.visible = true;
            })
    }

    showCounter() {
        this.drawFreespinRound();
        Commander.removeTween(this.frame);
        createjs.Tween.get(this.frame)
            .to({x: 0, y: 0}, 1000, createjs.Ease.cubicOut)
            .call(() => {
                Commander.removeTween(this.frame);
            });
    }

    hideCounter() {
        Commander.removeTween(this.frame);
        createjs.Tween.get(this.frame)
            .to({x: 0, y: -150}, 1000, createjs.Ease.cubicOut)
            .call(() => {
                Commander.removeTween(this.frame);
            });
    }

    drawFreespinRound() {
        this.text.current.text = (this.freespins.getRoundIndex()+1).toString();
        this.text.total.text = this.freespins.getFreeSpinNumber().toString();
    }

    end() {
        return new Promise(async res => {
            this.isRunning = false
            // this.commander.states.setState("wait");
            this.hideCounter();
            this.NormalWin.showLogo();
            await this.BigWin.animStart();
            this.BigWin.animateFlares(4000);
            this.animateText();
            this.commander.audio.playTrack("bwin_FreeSpins");
            this.commander.audio.playTrack("win_Counter_Loop");
            this.WinCounter.freespin(
                4000,
                this.commander.result.win,
                res
            );
        }).then(() => {
            // this.StickingWild.endFs();
            this.BigWin.layer.flares.visible = this.BigWin.layer.frame.visible = false;
            this.Coins.stop();
        });
    }

    animateText() {
        this.BigWin.showSprite(this.text.fsWin, () => {
            BigWin.pulseSprite(this.text.fsWin);
            pixiSetTimeout(5, () => {
                this.BigWin.endSprite(this.text.fsWin);
            })
        });
    }

    initCounter() {
        this.frame = new PIXI.Container();
        this.frame.position.set(0,-150);
        this.frame.addChild(Commander.getSprite("freespins_background.png", 641, 0, {x: .5, y: 0}));
        this.layer.addChild(this.frame);
    }

    initDoors() {
        this.doors.left = Commander.getSprite("door.png", -641, 0, {x: 0, y: 0});
        this.doors.right = Commander.getSprite("door.png", 1930, 0, {x: 0, y: 0});
        this.doors.right.scale.set(-1, 1);
        this.layer.addChild(this.doors.left);
        this.layer.addChild(this.doors.right);
    }

    initDoorLights() {
        this.lights = new PIXI.Container();
        let left = Commander.getSprite("door_light.png", 645, 360, {x: 1, y: .5});
        this.lights.addChild(left);

        let right = Commander.getSprite("door_light.png", 645, 360, {x: 1, y: .5});
        right.scale.set(-1, 1);
        this.lights.addChild(right);

        this.lights.alpha = 0;
        this.layer.addChild(this.lights);
    }

    initText() {
        this.text.fs = Commander.getSprite("freespins_text.png", 640, 310);
        this.text.fs.alpha = 0;

        this.text.fsWin = Commander.getSprite("free_spins_win.png", 640, 210);
        this.text.fsWin.alpha = 0;

        const style = {
            fontName: "free_spins_font-export",
            fontSize: 70,
            tint: 0xFFFFFF,
            align: 'center',
            letterSpacing: 0,
            maxWidth: 1280
        };

        this.text.current = new PIXI.BitmapText('', style);
        this.text.total =  new PIXI.BitmapText('', style);
        this.text.current.position.set(681, -10);
        this.text.total.position.set(761, -10);

        this.frame.addChild(this.text.current);
        this.frame.addChild(this.text.total);
        this.layer.addChild(this.text.fs);
        this.layer.addChild(this.text.fsWin);
    }
}